import {
  Linkedin,
  Instagram,
  Facebook,
  Twitter,
  Youtube,
  Link2,
} from 'lucide-react'

export const SOCIAL_NETWORKS = [
  {
    key: 'linkedin',
    label: 'LinkedIn',
    placeholder: 'https://linkedin.com/in/...',
    icon: Linkedin,
    color: '#0077B5',
    bgColor: '#0077B518',
  },
  {
    key: 'instagram',
    label: 'Instagram',
    placeholder: 'https://instagram.com/...',
    icon: Instagram,
    color: '#E1306C',
    bgColor: '#E1306C18',
  },
  {
    key: 'facebook',
    label: 'Facebook',
    placeholder: 'https://facebook.com/...',
    icon: Facebook,
    color: '#1877F2',
    bgColor: '#1877F218',
  },
  {
    key: 'twitter',
    label: 'X (Twitter)',
    placeholder: 'https://x.com/...',
    icon: Twitter,
    color: '#0F1419',
    bgColor: '#0F141918',
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    placeholder: 'https://tiktok.com/@...',
    icon: Link2,
    color: '#010101',
    bgColor: '#01010112',
  },
  {
    key: 'youtube',
    label: 'YouTube',
    placeholder: 'https://youtube.com/@...',
    icon: Youtube,
    color: '#FF0000',
    bgColor: '#FF000018',
  },
]

export const SOCIAL_LINK_KEYS = SOCIAL_NETWORKS.map((network) => network.key)

const isValidHttpUrl = (value) => {
  if (!value || typeof value !== 'string') return false
  try {
    const url = new URL(value)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
}

export const toOptionalUrl = (value) => (isValidHttpUrl(value) ? value : undefined)

export const mapSocialLinksToForm = (socialLinks = {}) =>
  SOCIAL_LINK_KEYS.reduce((acc, key) => {
    acc[`${key}_url`] = socialLinks[key] ?? ''
    return acc
  }, {})

export const buildSocialLinksPayload = (formData) => {
  const links = SOCIAL_LINK_KEYS.reduce((acc, key) => {
    const url = toOptionalUrl(formData[`${key}_url`])
    if (url) acc[key] = url
    return acc
  }, {})

  return Object.keys(links).length > 0 ? links : {}
}

export const getActiveSocialLinks = (socialLinks = {}) =>
  SOCIAL_NETWORKS.filter((network) => isValidHttpUrl(socialLinks[network.key]))
